import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const PASSWORD_PATTERN = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/;

export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors => {
    if (!PASSWORD_PATTERN.test(control.value)) {
      return { password: true };
    }

    return null;
  }
}
